import { useState } from "react";
import { Button } from "../components/ui/button";
import { Alert, AlertDescription } from "../components/ui/alert";
import { toast } from "react-toastify";
import { Input } from "../components/ui/input";
import { useApiFetch, errorMessage, toastError } from "src/lib/api";

export default function DeviceControl({ deviceIP, onClose, victronID }) {
  const [status, setStatus] = useState("");
  const apiFetch = useApiFetch();

  const [volume, setVolume] = useState("");
  console.log("[DEBUG] DeviceIP in DeviceControl: ", deviceIP);
  const sendCommand = async (key, value) => {
    try {
      const data = await apiFetch("/api/sendCommand", {
        method: "POST",
        body: { deviceIP, key, value },
      });
      if (!data) return;
      setStatus(JSON.stringify(data));
      toast({
        title: "Command Sent",
        description: `${key} set to ${value} successfully!`,
        autoClose: 3000,
      });
    } catch (error) {
      console.error("Error sending command:", error);
      setStatus(`Error: ${errorMessage(error)}`);
      toastError(error);
    }
  };

  const sendCommandVictron = async (key, value) => {
    try {
      const data = await apiFetch("/api/sendCommandVictron", {
        method: "POST",
        body: { deviceIP, key, value },
      });
      if (!data) return;
      setStatus(JSON.stringify(data));
      toast({
        title: "Command Sent",
        description: `${key} set to ${value} successfully!`,
        autoClose: 3000,
      });
    } catch (error) {
      console.error("Error sending command:", error);
      setStatus(`Error: ${errorMessage(error)}`);
      toastError(error);
    }
  };

  const resetDevice = async () => {
    try {
      const data = await apiFetch("/api/resetDevice", {
        method: "POST",
        body: { deviceIP },
      });
      if (!data) return;
      setStatus(JSON.stringify(data));
      toast({
        title: "Device Reset",
        description: "Device has been reset successfully!",
        autoClose: 3000,
      });
    } catch (error) {
      console.error("Error resetting device:", error);
      setStatus(`Error: ${errorMessage(error)}`);
      toastError(error);
    }
  };

  const handleVolumeChange = () => {
    const volumeValue = parseInt(volume);
    if (volumeValue >= 0 && volumeValue <= 60) {
      sendCommand("volume_speaker", volumeValue);
    } else {
      setStatus("Invalid volume. Please enter a number between 0 and 60.");
      toast({
        title: "Invalid Volume",
        description: "Please enter a number between 0 and 60.",
        variant: "destructive",
        autoClose: 3000,
      });
    }
  };

  return (
    <div className="p-4 max-w-md mx-auto"
    /* style={{ backgroundColor: "white"}} */>
      <button
        onClick={onClose}
        style={{
          position: "absolute",
          top: "10px",
          right: "10px",
          background: "transparent",
          border: "none",
          fontSize: "18px",
          cursor: "pointer",
        }}
      >
        &#10005; {/* This is the "X" symbol */}
      </button>
      <h1 className="text-2xl font-bold mb-4 text-custom-blue ">
        Device Control
      </h1>
      {!victronID && (
        <div className="space-y-2">
          { status !== "online" && (
            <Button
            onClick={() => sendCommand("rele_FO", 0)}
            className="w-full bg-custom-blue"
          >
            Turn ON Relé FO
          </Button>
          )}

          { status === "online"  && (
            <Button
            onClick={() => sendCommand("rele_FO", 1)}
            className="w-full bg-custom-blue"
          >
            Turn OFF Relé FO
          </Button>
          )}
        <div className="flex space-x-2 ">
          <Input
            type="number"
            placeholder="Volume (0-60)"
            value={volume}
            onChange={(e) => setVolume(e.target.value)}
            min="0"
            max="60"
          />
          <Button onClick={handleVolumeChange} className="bg-custom-blue">
            Set Volume
          </Button>
        </div>
        <Button
          onClick={() => sendCommand("estado", 1)}
          className="w-full bg-custom-blue"
        >
          Check Status
        </Button>
        <Button onClick={resetDevice} variant="destructive" className="w-full ">
          Reset Device
        </Button>
      </div>
      )}
      {victronID && (
        <div className="space-y-2">
          { status !== "online"  && (
            <Button
            onClick={() => sendCommandVictron("value", true)}
            className="w-full bg-custom-blue"
          >
            Turn ON Inverter
          </Button>
          )}
           { status === "online" && (
            <Button
            onClick={() => sendCommandVictron("value", false)}
            className="w-full bg-custom-blue"
          >
            Turn OFF Inverter
          </Button>
          )}
        <Button onClick={resetDevice} variant="destructive" className="w-full ">
          Reset Device
        </Button>
      </div>
      )}
      {status && (
        <Alert className="mt-4">
          <AlertDescription
            dangerouslySetInnerHTML={{
              __html: status.replace(/\n/g, "<br />"),
            }}
          />
        </Alert>
      )}
    </div>
  );
}